export const usePreventPageZoom = () => {
	const wheelListener = (e: WheelEvent) => {
		if (e.ctrlKey) {
			e.preventDefault()
		}
	}

	window.addEventListener("wheel", wheelListener, { passive: false })

	return () => {
		window.removeEventListener("wheel", wheelListener)
	}
}
